import React, { useMemo } from 'react';
const ControllerContext = /*#__PURE__*/ React.createContext(undefined);
export const ControllerProvider = /*#__PURE__*/ React.memo(({ children, wfActions, wfConfig, wfResults })=>{
    const value = useMemo(()=>({
            wfActions,
            wfConfig,
            wfResults
        }), [
        wfActions,
        wfConfig,
        wfResults
    ]);
    return /*#__PURE__*/ React.createElement(ControllerContext.Provider, {
        value: value
    }, children);
});
export function useController() {
    const context = React.useContext(ControllerContext);
    if (context === undefined) {
        throw new Error('useController must be used within a ControllerProvider');
    }
    return context;
}

//# sourceMappingURL=controller-context.js.map